import { createSimpleGlobalState } from "src/hooks/simpleGlobalState"

import { Category } from "./category"

export type FilterSorting =
  | "default"
  | "favorite"
  | "alphabeticUp"
  | "alphabeticDown"
  | "priceUp"
  | "priceDown"

export type FilterBy = {
  category: Category | null
}

export type Filter = {
  search: string
  filterBy?: FilterBy
  sortBy: FilterSorting
  disableSelectionDialog?: boolean
}

const { getValue, setValue, mergeValue, useValue, resetValue } =
  createSimpleGlobalState<Filter>(
    {
      search: "",
      sortBy: "favorite",
    },
    "shop-filter",
  )

export {
  getValue as getFilter,
  mergeValue as mergeFilter,
  resetValue as resetFilter,
  setValue as setFilter,
  useValue as useFilter,
}
